var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#3B76CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.66 221.5C103.636 221.5 114.076 211.996 114.076 197.452C114.076 183.052 103.636 173.476 88.588 173.476H69.652V221.5H88.66ZM88.588 212.5H79.876V182.476H88.66C98.452 182.476 103.636 189.028 103.636 197.452C103.636 205.66 98.092 212.5 88.588 212.5Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.156 222.364C158.628 222.364 169.212 211.996 169.212 197.524C169.212 183.052 158.628 172.684 144.156 172.684C129.612 172.684 119.028 183.052 119.028 197.524C119.028 211.996 129.612 222.364 144.156 222.364ZM144.156 213.292C135.228 213.292 129.54 206.452 129.54 197.524C129.54 188.524 135.228 181.756 144.156 181.756C153.012 181.756 158.7 188.524 158.7 197.524C158.7 206.452 153.012 213.292 144.156 213.292Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.714 222.364C210.226 222.364 216.346 216.532 219.73 210.556L210.946 206.308C208.93 210.196 204.61 213.292 199.714 213.292C190.93 213.292 184.594 206.596 184.594 197.524C184.594 188.452 190.93 181.756 199.714 181.756C204.61 181.756 208.93 184.852 210.946 188.74L219.73 184.42C216.346 178.372 210.226 172.684 199.714 172.684C185.242 172.684 174.082 182.692 174.082 197.524C174.082 212.284 185.242 222.364 199.714 222.364Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.54aa6ab2b1f94bc533b600cbb21cf7ca.svg";
export { ForwardRef as ReactComponent };